<mat-card>
  <mat-card-title>
    <mat-icon>slow_motion_video</mat-icon> Airman Flight and Duty Time Report
  </mat-card-title>
  <mat-divider></mat-divider>

  <mat-card-content>
    <fl-date-range-picker
      (onInit)="updateDateRange($event)"
      (onChange)="updateDateRangeAndRoute($event)"
      [rangeKey]="dateRangeParam$ | async"
      [startDate]="startDateParam$ | async"
      [endDate]="endDateParam$ | async"
    ></fl-date-range-picker>
  </mat-card-content>

  <mat-card-content>
    <mat-divider></mat-divider>
    <div *tdLoading="let stats; until: stats$ | async; type: 'circle'; color: 'accent'">
      <fl-airman-flight-duty-report *ngIf="stats" [stats]="stats"></fl-airman-flight-duty-report>
    </div>
  </mat-card-content>
</mat-card>
